import { iaRa } from 'lib/helpers/utility';

import { isSameUrlFilters } from 'components/shared/Filters/lib/urlFilters';
import { applyFilterHandler } from 'components/shared/Filter/lib/helpers/handleAppliedFilter';

const TEXT_FORMULA = 'contains';

const searchFieldsOf = (defaultFilters) =>
  iaRa(defaultFilters?.search?.fields)
    .map((item) => (typeof item === 'string' ? item : item?.field))
    .filter(Boolean);

const searchEntry = (searchTerm, fields) => ({
  type: 'search',
  values: { searchTerm, fields }
});

const idEntry = (config, id) =>
  iaRa(config.allowed_operators).includes(TEXT_FORMULA)
    ? { ...config, formula: TEXT_FORMULA, type: 'text', values: String(id) }
    : { ...config, formula: 'is', values: [{ value: id, label: String(id) }] };

const typeEntry = (highlight, defaultFilters) =>
  highlight.type && defaultFilters?.type
    ? { type: [{ ...defaultFilters.type, formula: 'is', values: [{ value: highlight.type }] }] }
    : {};

const byId = (highlight, defaultFilters) => {
  if (highlight.id == null || highlight.isolateBy === 'name') return null;
  const key = ['id', `${highlight.kind}_id`].find((name) => defaultFilters?.[name]);
  if (key) return { [key]: [idEntry(defaultFilters[key], highlight.id)] };
  if (!searchFieldsOf(defaultFilters).includes('id')) return null;
  return { search: [searchEntry(String(highlight.id), ['id'])] };
};

const byText = (highlight, defaultFilters) => {
  const match = String((highlight.id != null && highlight.name) || highlight.match || '').trim();
  const fields = searchFieldsOf(defaultFilters);
  return match && fields.length ? { search: [searchEntry(match, fields)] } : null;
};

const kindName = (kind) => {
  const text = String(kind || 'record').replace(/_/g, ' ');
  return `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
};

export const recordNameOf = (highlight) =>
  highlight.label || `${kindName(highlight.kind ?? highlight.key)} #${highlight.id}`;

export const isTableFiltered = (table) =>
  !!table?.filters &&
  !isSameUrlFilters(
    table.filters,
    applyFilterHandler(table.defaultFilters || {}, null),
    table.defaultFilters
  );

export const isolatingFilterOf = (highlight, defaultFilters) => {
  if (!highlight) return null;
  const filter = byId(highlight, defaultFilters) || byText(highlight, defaultFilters);
  return filter && { ...filter, ...typeEntry(highlight, defaultFilters) };
};

export const showHighlighted = (highlight, table) => {
  const filter = table?.changeFilters && isolatingFilterOf(highlight, table.defaultFilters);
  if (!filter) {
    table?.resetFilters?.();
    return;
  }
  table.changeFilters(() => ({ ...applyFilterHandler(table.defaultFilters, null), ...filter }));
};
